import { getRandomColor, SITE_ICON_COLOR_LIST } from "@/utils/color";
import { getResizedImageUrl } from "@/utils/common";
import React from "react";
import { twMerge } from "tailwind-merge";

interface ISiteIconProps {
  name: string;
  icon?: string | null;
  className?: string;
}

const SiteIcon = ({ icon, name, className }: ISiteIconProps) => {
  return icon ? (
    <span
      className={twMerge(
        "flex-none block w-6 h-6 rounded-full leading-[0]",
        className
      )}
      style={{
        backgroundColor: "#efefef",
        backgroundSize: "cover",
        backgroundImage: `url(${getResizedImageUrl(icon, "100x100")})`,
      }}
    ></span>
  ) : (
    <span
      className={twMerge(
        "flex flex-none w-6 h-6 text-white rounded-full center-center",
        className
      )}
      style={{
        background: getRandomColor(name[0] || "", SITE_ICON_COLOR_LIST),
      }}
    >
      {name[0]}
    </span>
  );
};

export default React.memo(SiteIcon);
